import React, { useRef } from 'react';
import { useStagePointer } from './useStagePointer';
import './LandingStage.css';

const markSrc = `${process.env.PUBLIC_URL}/mark-white.png`;

const LandingStage = () => {
  const stageRef = useRef(null);
  const { replayIntro } = useStagePointer(stageRef);

  return (
    <main
      ref={stageRef}
      className="stage"
      aria-label="Operation LTD"
      onClick={replayIntro}
    >
      <div className="blob" />
      <div className="layer vignette" />
      <div className="center">
        <div className="tilt">
          <div className="entrance">
            <img
              className="mark"
              src={markSrc}
              alt="Operation LTD"
              draggable={false}
            />
          </div>
        </div>
      </div>
      <div className="layer grain" />
      <div className="layer cursor-glow" />
    </main>
  );
};

export default LandingStage;
